// 使用：$t('page.key')、$t('component.key')
// 规范：通过页面、或者组件分组

export default {
    locale: 'zh-cn',
    common: {
     
    },
    components: {
      PopEnsure: {
        confirmBtn: '确认',
        cancelBtn: '取消'
      }
    },
    page: {
      homepage: {
        home: '首页',
        ac: '代理合作',
        aboutus: '关于我们',
  
        title1: '结交有趣的人',
        detail1: '唱歌、跳舞、聊天，身边总有朋友相伴',
  
        videolive: '视频直播',
        videolive1: '特效礼物，',
        videolive2: '热情互动',
        videolive3: '结交能歌善舞的才艺主播',
  
        pk: '激情PK',
        pktext1: '激情四溢，扣人心弦',
        pktext2: '观看主播间的才艺比拼，支持你的最爱',
  
        vdparty: '视频派对',
        vdpartyt1: '无限的欢乐与激动',
        vdpartyt2: '与魅力四射的朋友面对面视频聊天',
  
        vcparty: '语音派对',
        vcpartyt1: '聊天交友，玩法多样',
        vcpartyt2: '通过语音聊天交友，畅所欲言',
  
        flus: '关注我们',
  
        page2text1: '联系我们',
        page2text2: '新代理合作',
        page2text3: '商业合作',
        page3text1: 'Joyo Live是一个直播平台。我们致力于连接来自世界各地的朋友，打造一个展示才艺、享受乐趣和互动的平台。我们的目标是帮助普通人实现成为明星的梦想。',
  }
    },
    router: {}
  }
  